(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    

var loadProductRecommendationsIntoSection = function() {
  var section = document.querySelector(".related-products");
  if (!section) return;

  var request = new XMLHttpRequest();
  request.open("GET", section.dataset.url);

  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      section.innerHTML = container.querySelector(".related-products").innerHTML;
      initRelatedCarousel();
    }
  };

  request.send();
};

function initRelatedCarousel() {

  var wrappers = document.querySelectorAll(".related-carousel-wrapper");

  wrappers.forEach(function(wrapper) {

    var carousel = wrapper.querySelector(".related-carousel");
    var leftArrow = wrapper.querySelector(".carousel-arrow--left");
    var rightArrow = wrapper.querySelector(".carousel-arrow--right");
    var progressBar = wrapper.querySelector(".carousel-progress-bar");

    if (!carousel) return;

    var autoplay = carousel.dataset.autoplay === "true";
    var speed = parseInt(carousel.dataset.speed) * 1000;

    function getScrollAmount() {
      var item = carousel.querySelector(":scope > *");
      if (!item) return 0;
      return item.offsetWidth + 24;
    }

    leftArrow.addEventListener("click", function() {
      carousel.scrollBy({ left: -getScrollAmount() * 3, behavior: "smooth" });
    });

    rightArrow.addEventListener("click", function() {
      carousel.scrollBy({ left: getScrollAmount() * 3, behavior: "smooth" });
    });

    carousel.addEventListener("scroll", function() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;
      var percent = (carousel.scrollLeft / maxScroll) * 100;
      progressBar.style.width = percent + "%";
    });

    if (autoplay) {
      setInterval(function() {
        carousel.scrollBy({ left: getScrollAmount() * 3, behavior: "smooth" });

        if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth) {
          carousel.scrollTo({ left: 0, behavior: "smooth" });
        }
      }, speed);
    }

  });
}

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});

loadProductRecommendationsIntoSection();


  } catch(e) { console.error(e); }
})();
})();
